<template>
  <w-modal v-model="open" type="danger">
    <h1 slot="header">{{ setting.title }}</h1>
    <div slot="content" class="content">
      <p>
        <span class="icon-alert-circle" /> {{ setting.description }}
      </p>
    </div>
    <div slot="footer">
      <w-button
        :disabled="loading"
        @click="open = false"
        color-type="error"
        type="link"
      >
        取消
      </w-button>
      <w-button
        :disabled="loading"
        @click="onConfirm"
        class="ml-2"
        color-type="error"
      >
        {{ loading ? setting.confirmLoading : setting.confirmText }}
      </w-button>
    </div>
  </w-modal>
</template>

<script>
import OperationActionModal from './OperationActionModal';

export default OperationActionModal;
</script>
